export function buildUrl(server, endpoint, queryParams = {}, item = null) {
    const queryString = new URLSearchParams(queryParams).toString();
    return `${server}${endpoint}${item ? `/${encodeURIComponent(item)}` : ''}${queryString != 'null=' ? `?${queryString}` : ''}`;
  }